import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useGetLessonFeedback(data = {}) {
  const { enabled = false, config = {}, queryKey = ['lesson-feedback'] } = data;
  const { params = {} } = config;
  const { privateFetch } = useContext(FetchContext);

  const fetchFeedback = () => privateFetch.get('/v1/admin/lesson-feedback', { params });

  return useQuery(queryKey, fetchFeedback, {
    enabled,
    keepPreviousData: true,
  });
}

export default useGetLessonFeedback;
